module.exports = __webpack_public_path__ + "img/scroll-left.a2a7340d.png";